import React from 'react';
import { motion } from 'framer-motion';
import { FaChevronRight } from 'react-icons/fa';
import ModuleRevealVisual from './ModuleRevealVisuals';

const ModuleRevealCard = ({ layerKey, revealMeta, onOpen }) => {
  const RevealIcon = revealMeta.Icon;

  return (
    <motion.button
      key={`reveal_${layerKey}`}
      type="button"
      onClick={onOpen}
      className="lumirae-guided-module-reveal"
      data-reveal={revealMeta.tone}
      data-reveal-style={revealMeta.revealStyle || 'gift_layer'}
      data-texture={revealMeta.texture || 'none'}
      data-final-layer={revealMeta.isFinalLayer ? 'true' : 'false'}
      initial={{ opacity: 0, y: 24, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -18, scale: 0.98 }}
    >
      <span className="lumirae-guided-module-reveal-art" aria-hidden="true">
        <ModuleRevealVisual tone={revealMeta.tone} revealMeta={revealMeta} />
        <span className="lumirae-guided-module-reveal-icon">
          <RevealIcon />
        </span>
      </span>
      <span className="lumirae-opening-label">
        {revealMeta.kicker}
      </span>
      <strong>{revealMeta.title}</strong>
      <small>{revealMeta.copy}</small>
      <span className="lumirae-guided-module-reveal-action">
        {revealMeta.action}
        <FaChevronRight />
      </span>
    </motion.button>
  );
};

export default ModuleRevealCard;
